import {ApplicationConfig, provideZoneChangeDetection, ErrorHandler} from '@angular/core';
import {provideRouter, withComponentInputBinding} from '@angular/router';
import {routes} from './app.routes';
import {provideHttpClient, withInterceptors, withXhr} from '@angular/common/http';
import {AuthInterceptor} from './core/auth/auth.interceptor';
import {provideAnimationsAsync} from '@angular/platform-browser/animations/async';
import {provideStore} from '@ngrx/store'
import {UserReducer} from "./reducers/user.reducer";
import {provideEffects} from '@ngrx/effects';
import {UserEffects} from "./reducers/user.effects";
import {HubReducer} from "./reducers/hub.reducer";
import { BrowserModule } from '@angular/platform-browser';
import { importProvidersFrom } from '@angular/core';
import { ModalModule } from 'ngx-bootstrap/modal';
import { GlobalErrorHandler } from './global-error-handler';
import { globalHttpInterceptor } from './shared/interceptors/global-http.interceptor';


export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({eventCoalescing: true}),
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(withXhr(), withInterceptors([globalHttpInterceptor,AuthInterceptor])),
    provideAnimationsAsync(),
    provideStore({['user']: UserReducer, ['hub']: HubReducer}, {
      metaReducers: []
    }),
    provideEffects([UserEffects]),
    importProvidersFrom(BrowserModule), 
    importProvidersFrom(ModalModule),
    provideRouter(routes),
    { provide: ErrorHandler, useClass: GlobalErrorHandler }
  ]
};
